<template>
  <div class="dashboard-analytics">
    <h2>Analytics</h2>
    <p>Coming soon...</p>
  </div>
</template>

<script>
export default {
  name: 'DashboardAnalytics'
}
</script>

<style scoped>
.dashboard-analytics {
  padding: 24px;
}
</style> 